import React from "react";
import { Form, Col, Button } from "react-bootstrap";
import {
    StyledModal,
    StyledModalBody,
    StyledModalFooter,

} from "../../../../Styling/styledModal/styledModals";


const BekreftInnsending = (props) => {

    const messages = props.bsFuncs.messages    

    return (

        <StyledModal centered show={true} onHide={props.bsFuncs.cancelHandler}>

            <StyledModalBody>
                <h4>{messages.BE_Header}</h4>
                <p style={{whiteSpace: "pre-line"}}>{props.bsFuncs.confirmMessage}</p>
            </StyledModalBody>
           
            <StyledModalFooter>
                <Button variant="secondary" onClick={props.bsFuncs.okHandler}>
                    {messages.BE_Ja}
                </Button>
                <Button variant="secondary" onClick={props.bsFuncs.cancelHandler}>
                    {messages.BE_Nei}
                </Button>
            </StyledModalFooter>

        </StyledModal>
    );
};

export default BekreftInnsending;